import React from 'react';
import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import { getStoresListPaginate } from '../../modules/Api';
import './brandRemoteSelect.css';

const { Option } = Select;

class BrandRemoteSelect extends React.Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    this.fetchBrand = debounce(this.fetchBrand, 800);
    this.state = {
      data: [],
      value: props.value,
      fetching: false,
    };
    this.init = false;
  }

  fetchBrand = value => {
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({ data: [], fetching: true });

    getStoresListPaginate(`name=${value}&per_page=50`, function(body) {
      if (fetchId !== this.lastFetchId) {
        // for fetch callback order
        return;
      }
      const data = body.data.map(brand => ({
        text: `${brand.name}`,
        value: brand.id,
      }));
      this.setState({ data, fetching: false });
    }.bind(this))
  }

  handleChange = value => {
    this.props.selectChanged(value);
    this.setState({
      value,
      data: [],
      fetching: false,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value && this.init === false) {
      this.init = true;
      this.setState({ value: nextProps.value });
    }
  }

  render() {
    const { fetching, data, value } = this.state;
    return (
      <Select
        mode="multiple"
        labelInValue
        value={value}
        placeholder="انتخاب برندها"
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        onSearch={this.fetchBrand}
        onChange={this.handleChange}
        style={{ width: '100%', direction: 'rtl', textAlign: 'right', float: 'right' }}
      >
        {data.map(d => (
          <Option key={d.value}>{d.text} - ({d.value})</Option>
        ))}
      </Select>
    );
  }
}

export default BrandRemoteSelect


// WEBPACK FOOTER //
// ./src/components/Brand/BrandRemoteSelect.js